import {
    CLEAR,
    BILLING_LIST_REQUEST,
    BILLING_LIST_SUCCESSFUL,
    BILLING_LIST_FAILED,
    BILLING_SET_FILTER,
    BILLING_SET_SCOPE,
    BILLING_SET_RESOLVED_PROFILE,
    BILLING_FETCH_CANCELLED,
    GET_ONGOING_TRIP_RECEIPTS,
    SET_ONGOING_TRIP_RECEIPTS_LOADING,
    SET_ONGOING_TRIP_RECEIPTS,
} from './types';

export const clear = () => ({ type: CLEAR });
export const billingListRequest = () => ({ type: BILLING_LIST_REQUEST });
export const billingListSuccessful = data => ({ type: BILLING_LIST_SUCCESSFUL, payload: data });
export const billingListFailed = () => ({ type: BILLING_LIST_FAILED });
export const billingSetFilter = (year, month, profile, scope) => ({
    type: BILLING_SET_FILTER,
    payload: { year, month, profile, scope },
});

// Registers the currently-active billing tab without triggering a refetch.
// Pass `filter` to also apply cached filter values (e.g. when restoring a tab
// whose data is still up to date); omit it to just record the scope.
export const billingSetScope = (scope, filter) => ({
    type: BILLING_SET_SCOPE,
    payload: { scope, filter },
});

// Updates the resolved profile id in state without triggering a refetch.
// Dispatched from the list saga the first time it resolves a personal profile.
export const billingSetResolvedProfile = profile => ({
    type: BILLING_SET_RESOLVED_PROFILE,
    payload: { profile },
});

// Clears per-scope fetching flags when takeLatest cancels an in-flight list saga.
export const billingFetchCancelled = scopesFetched => ({
    type: BILLING_FETCH_CANCELLED,
    payload: { scopesFetched },
});

/**
 * Action to initiate the retrieval of ongoing trip receipts
 * @param {Array<string>} journeysIds - Array of ongoing trip IDs for which receipts are to be fetched
 * @returns {Object} Action object to trigger the saga for fetching ongoing trip receipts
 */
export const getOngoingTripReceipts = journeysIds => ({
    type: GET_ONGOING_TRIP_RECEIPTS,
    payload: journeysIds,
});
/**
 * @param {boolean} loading - Indicates if the ongoing trip receipts are loading
 * @returns {void}
 */
export const setOngoingTripReceiptsLoading = loading => ({
    type: SET_ONGOING_TRIP_RECEIPTS_LOADING,
    payload: loading,
});
/**
 * Sets the ongoing trip receipts in the store
 * @param {Record<string, Record<string, object>>} data - The ongoing trip receipts data
 *   where keys are trip IDs and values are objects containing receipt objects
 *   Example structure:
 *   {
 *     "tripIdA": {
 *       receiptA: {},
 *       receiptB: {},
 *     },
 *     "tripIdB": {
 *       receiptA: {},
 *       receiptB: {},
 *       receiptC: {},
 *     }
 *   }
 * @returns {Object} Action object with the receipt data as payload
 */
export const setOngoingTripReceipts = data => ({
    type: SET_ONGOING_TRIP_RECEIPTS,
    payload: data,
});
